// extracted by mini-css-extract-plugin
module.exports = {"Empty":"Empty_Empty__3mpqF","image":"Empty_image__3vfy2","message":"Empty_message__2T52j"};